import { Pipe, PipeTransform } from '@angular/core';
import { convertNumberFormat } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertNumber'
})
export class ConvertNumberPipe implements PipeTransform {

  transform(value: number){
    const language = "en-AU"
    return convertNumberFormat(language, value);
  }

}
